/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  function replaceStaleHeaderAccountComponents(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var accounts = scope.querySelectorAll(".site-nav__icons shopify-account");

    accounts.forEach(function (account) {
      var link = document.createElement("a");
      link.href = "/account";
      link.className = "site-nav__link site-nav__link--icon js-no-transition";
      link.setAttribute("aria-label", "Account");

      var avatar = account.querySelector('[slot="signed-out-avatar"]');
      if (avatar) {
        Array.prototype.forEach.call(avatar.childNodes, function (node) {
          var clone = node.cloneNode(true);
          if (clone.nodeType === Node.ELEMENT_NODE) {
            clone.removeAttribute("slot");
          }
          link.appendChild(clone);
        });
      }

      var fallback = document.createElement("span");
      fallback.className = "icon__fallback-text visually-hidden";
      fallback.textContent = "Account";
      link.appendChild(fallback);

      account.replaceWith(link);
    });
  }

  replaceStaleHeaderAccountComponents(document);

  DOMready(function () {
    replaceStaleHeaderAccountComponents(document);

    var headerIconObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            replaceStaleHeaderAccountComponents(node);
          }
        });
      });
    });

    headerIconObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
